"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _H = _interopRequireDefault(require("../elements/headings/H4"));

var _UISplitLayout = _interopRequireDefault(require("../layout/UISplitLayout"));

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var _devWarnings = require("../utils/devWarnings");

// empty state styling is characterized by copious whitespace, per design
// vertical orientation differs to more closely match UIErrorMessage styles
var OUTER_MARGIN = 40;
var Outer = (0, _styledComponents.default)(function (props) {
  var __flush = props.flush,
      __layout = props.layout,
      __maxWidth = props.maxWidth,
      rest = (0, _objectWithoutProperties2.default)(props, ["flush", "layout", "maxWidth"]);
  return _react.default.createElement(_UISplitLayout.default, rest);
}).withConfig({
  displayName: "UIEmptyState__Outer",
  componentId: "sc-17fm77z-0"
})(["margin:", " auto;margin-bottom:", ";margin-top:", ";max-width:", ";padding-left:", ";width:100%;"], function (props) {
  return props.layout === 'vertical' ? (0, _Styles.toPx)(OUTER_MARGIN) : (0, _Styles.toPx)(OUTER_MARGIN * 2);
}, function (props) {
  return props.flush && '0';
}, function (props) {
  return props.flush && '0';
}, function (props) {
  return (0, _Styles.toPx)(props.maxWidth);
}, _sizes.EMPTY_STATE_PADDING_X);
var Inner = (0, _styledComponents.default)(_UISplitLayout.default.defaultProps.InnerWrapper).withConfig({
  displayName: "UIEmptyState__Inner",
  componentId: "sc-17fm77z-1"
})(["margin-left:-", ";margin-top:-", ";"], _sizes.EMPTY_STATE_PADDING_X, _sizes.EMPTY_STATE_PADDING_Y);
var SLOT_PADDING_STYLES = (0, _styledComponents.css)(["margin:auto;padding-left:", ";padding-top:", ";"], _sizes.EMPTY_STATE_PADDING_X, _sizes.EMPTY_STATE_PADDING_Y);
var PrimarySlot = (0, _styledComponents.default)(_UISplitLayout.default.defaultProps.Primary).withConfig({
  displayName: "UIEmptyState__PrimarySlot",
  componentId: "sc-17fm77z-2"
})(["", ";margin-top:0;text-align:", ";"], SLOT_PADDING_STYLES, function (props) {
  return props.layout === 'vertical' && 'center';
});
var SecondarySlot = (0, _styledComponents.default)(_UISplitLayout.default.defaultProps.Secondary).withConfig({
  displayName: "UIEmptyState__SecondarySlot",
  componentId: "sc-17fm77z-3"
})(["", ";margin-bottom:", ";margin-top:0;text-align:", ";"], SLOT_PADDING_STYLES, function (props) {
  return props.layout === 'vertical' && '20px';
}, function (props) {
  return props.layout === 'vertical' && 'center';
});

var UIEmptyState = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIEmptyState, _PureComponent);

  function UIEmptyState() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIEmptyState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIEmptyState)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.Primary = function (props) {
      var _this$props = _this.props,
          layout = _this$props.layout,
          _primaryContentWidth = _this$props._primaryContentWidth,
          reverseOrder = _this$props.reverseOrder,
          secondaryContent = _this$props.secondaryContent;
      var computedPrimaryContentWidth = secondaryContent ? _primaryContentWidth : '100%';
      return _react.default.createElement(PrimarySlot, Object.assign({}, props, {
        basis: layout === 'horizontal' ? computedPrimaryContentWidth : 'auto',
        grow: 9999,
        layout: layout,
        order: reverseOrder ? 1 : 0,
        shrink: 1
      }));
    };

    _this.Secondary = function (props) {
      var _this$props2 = _this.props,
          layout = _this$props2.layout,
          secondaryContentWidth = _this$props2.secondaryContentWidth;
      var computedPadding = parseInt(_sizes.EMPTY_STATE_PADDING_X, 10);
      var computedSecondaryContentWidth = layout === 'horizontal' ? secondaryContentWidth + computedPadding : 'auto';
      return _react.default.createElement(SecondarySlot, Object.assign({}, props, {
        basis: computedSecondaryContentWidth,
        grow: 1,
        layout: layout,
        shrink: 1
      }));
    };

    return _this;
  }

  (0, _createClass2.default)(UIEmptyState, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          layout = _this$props3.layout,
          primaryContent = _this$props3.primaryContent,
          primaryContentClassName = _this$props3.primaryContentClassName,
          __primaryContentWidth = _this$props3._primaryContentWidth,
          __reverseOrder = _this$props3.reverseOrder,
          secondaryContent = _this$props3.secondaryContent,
          secondaryContentClassName = _this$props3.secondaryContentClassName,
          __secondaryContentWidth = _this$props3.secondaryContentWidth,
          titleText = _this$props3.titleText,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["className", "layout", "primaryContent", "primaryContentClassName", "_primaryContentWidth", "reverseOrder", "secondaryContent", "secondaryContentClassName", "secondaryContentWidth", "titleText"]);
      var renderedHeading;

      if ((0, _react.isValidElement)(titleText) && !titleText.type.isI18nElement) {
        (0, _devWarnings.warnIfFragment)(titleText, UIEmptyState.displayName, 'titleText');
        renderedHeading = titleText;
      } else if (titleText != null) {
        renderedHeading = _react.default.createElement(_H.default, null, titleText);
      }

      (0, _devWarnings.warnIfFragment)(primaryContent, UIEmptyState.displayName, 'primaryContent');
      var renderedPrimaryContent = [renderedHeading != null ? (0, _react.cloneElement)(renderedHeading, {
        key: 'heading '
      }) : renderedHeading, (0, _react.isValidElement)(primaryContent) ? (0, _react.cloneElement)(primaryContent, {
        key: 'content'
      }) : primaryContent];
      return _react.default.createElement(Outer, Object.assign({}, rest, {
        className: className,
        layout: layout,
        orientation: layout,
        InnerWrapper: Inner,
        Primary: this.Primary,
        primaryClassName: primaryContentClassName,
        primaryContent: renderedPrimaryContent,
        Secondary: this.Secondary,
        secondaryClassName: secondaryContentClassName,
        secondaryContent: secondaryContent
      }));
    }
  }]);
  return UIEmptyState;
}(_react.PureComponent);

exports.default = UIEmptyState;
UIEmptyState.propTypes = {
  flush: _propTypes.default.bool.isRequired,
  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  maxWidth: _propTypes.default.number,
  primaryContent: _propTypes.default.node.isRequired,
  primaryContentClassName: _propTypes.default.string,

  /**
   * _primaryContentWidth:
   * This prop is kept as an escape hatch, but 200 is used as the minimum
   * threshold for keeping text readable as horizontal space squishes down
   */
  _primaryContentWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  reverseOrder: _propTypes.default.bool.isRequired,
  secondaryContent: _propTypes.default.node,
  secondaryContentClassName: _propTypes.default.string,
  secondaryContentWidth: _propTypes.default.number,
  titleText: _propTypes.default.node
};
UIEmptyState.defaultProps = {
  flush: false,
  layout: 'horizontal',
  maxWidth: 815,
  reverseOrder: false,
  secondaryContentWidth: 350,
  _primaryContentWidth: 200
};
UIEmptyState.displayName = 'UIEmptyState';
module.exports = exports.default;